// 会员权益首页
export default [
	{
		path: '/member-benefits',
		name: 'MemberBenefits',
		component: () => import('@/views/memberBenefits/index'),
		meta: { title: '会员权益' }
	},
	{
		path: '/term',
		name: 'Term',
		component: () => import('@/views/memberBenefits/term'),
		meta: { title: '会员权益说明' }
	},
	{
		path: '/law',
		name: 'Law',
		component: () => import('@/views/memberBenefits/law'),
		meta: { title: '会员升级及权益变更法律说明' }
	},
	{
		path: '/recordRemark',
		name: 'RecordRemark',
		component: () => import('@/views/user/remark/recordRemark.vue'),
		meta: { title: '会员权益使用记录说明' }
	}
]
